export const SET_AUTH = 'set-auth';
export const SET_RESTAURANT_ID = 'set-restaurant-id';
export const SET_RESTAURANT_LOADER = 'set-restaurant-loader';
export const SET_FIREBASE_TOKEN = 'set-firbase-token';
export const SET_RESTAURANT_LIST = 'set-restaurant-list';
export const SET_REDEME_POINTS_ON_PURCHASE = 'set-redeme-points-on-purchase';
export const SET_RESTAURANT_DESCRIPTIONS = 'set-restaurant-descriptions';
